import _typeof from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import {
// 	addObj,
// 	copyObj,
// 	updateObj,
// 	getCategory
// } from '@/api/visual/visual';
import { addObj, copyObj, updateObj, getCategory as _getCategory } from '@/api/visual/visual';
import pick from 'lodash.pick';
export default {
  props: ['category'],
  name: "CreateScreen",
  data: function data() {
    return {
      validatorRules: {
        category: {
          rules: [{
            required: true,
            message: '请选择 分组!'
          }]
        },
        title: {
          rules: [{
            required: true,
            message: '请输入 大屏名称!'
          }]
        },
        width: {
          rules: [{
            required: true,
            message: '请输入 宽度!'
          }]
        },
        height: {
          rules: [{
            required: true,
            message: '请输入 高度!'
          }]
        },
        password: {
          rules: [{
            required: false,
            message: '请输入 密码!'
          }]
        }
      },
      disableSubmit: false,
      dictArr: [],
      wrapperCol: {
        xs: {
          span: 10
        },
        sm: {
          span: 16
        }
      },
      labelCol: {
        xs: {
          span: 5
        },
        sm: {
          span: 5
        }
      },
      list: [{
        id: 0,
        title: '空白模板',
        backgroundUrl: 'https://oss.bladex.vip/caster/upload/20211026/359aec0be15cc93ad168c36f2d8ad0a1.jpg'
      }, {
        id: 1,
        title: "数据大屏模板1",
        backgroundUrl: "https://oss.bladex.vip/caster/upload/20201120/59ed8621a5e3518aeea50a78f48de52f.jpg"
      }, {
        id: 2,
        title: "数据大屏模板2",
        backgroundUrl: "https://oss.bladex.vip/caster/upload/20201123/abe47c7959de86f7b1b7e6134b7c8e7c.jpg"
      }, {
        id: 3,
        title: "数据大屏模板3",
        backgroundUrl: "https://oss.bladex.vip/caster/upload/20201120/ba6387c840d534047d55dc65e97b2ae4.jpg"
      }, {
        id: 4,
        title: "数据大屏模板4",
        backgroundUrl: "https://oss.bladex.vip/caster/upload/20201122/2bcf7deba047b28954099fea71b64c29.jpg"
      }, {
        id: 6,
        title: "数据大屏模板5",
        backgroundUrl: "https://oss.bladex.vip/caster/upload/20210730/8bb6300dea753536bb63a391021267e3.jpg"
      }, {
        id: 7,
        title: "数据大屏模板6",
        backgroundUrl: "https://oss.bladex.vip/caster/upload/20210725/2603641a5f510994ccc740191673e96f.jpg"
      }, {
        id: 8,
        title: "数据大屏模板7",
        backgroundUrl: "https://oss.bladex.vip/caster/upload/20211011/a5b594bf7cce334a591830323ab216ee.jpg"
      }],
      count: 0,
      form: this.$form.createForm(this),
      model: {
        title: '',
        password: '',
        category: '',
        width: '1920',
        height: '1080'
      },
      option: {
        submitText: '创建大屏',
        size: 'medium',
        column: [{
          label: '分组',
          prop: 'category',
          span: 24,
          labelWidth: 100,
          type: 'select',
          dicUrl: this.$website.url + '/sys/dict/getDictItems/visual_category',
          props: {
            label: 'title',
            value: 'value'
          },
          rules: [{
            required: true,
            message: "请选择分组",
            trigger: "blur"
          }]
        }, {
          label: '大屏名称',
          span: 24,
          labelWidth: 100,
          prop: 'title',
          rules: [{
            required: true,
            message: "请输入大屏名称",
            trigger: "blur"
          }]
        }, {
          label: '大屏尺寸',
          span: 14,
          labelWidth: 100,
          prop: 'width',
          placeholder: '请输入宽度',
          rules: [{
            required: true,
            message: "请输入大屏尺寸",
            trigger: "blur"
          }]
        }, {
          label: '',
          span: 10,
          labelWidth: 1,
          prop: 'height',
          placeholder: '请输入高度',
          rules: [{
            required: true,
            message: "请输入大屏尺寸",
            trigger: "blur"
          }]
        }, {
          label: '密码',
          span: 24,
          type: 'password',
          labelWidth: 100,
          prop: 'password'
        }]
      }
    };
  },
  computed: {
    active: function active() {
      return this.list[this.count] || {};
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.model.category = this.category;
    console.log(_typeof(this.model.category));
    this.getCategory();
    this.$nextTick(function () {
      _this.form.setFieldsValue(pick(_this.model, 'title', 'password', 'category', 'width', 'height'));
    });
  },
  methods: {
    getCategory: function getCategory() {
      var _this2 = this;

      _getCategory().then(function (res) {
        console.log('res', res);

        if (res.success) {
          _this2.dictArr = res.result;
        }
      });
    },
    handleSave: function handleSave() {
      var _this3 = this;

      this.form.validateFields(function (err, values) {
        if (!err) {
          var form = Object.assign(_this3.model, values);
          console.log('form', form);
          console.log('form', _this3.active);
          console.log('form', _this3.count);

          if (_this3.count == 0) {
            addObj(form).then(function (res) {
              var id = res.result.id;

              _this3.handleEdit({
                id: id
              });

              _this3.$message.success('添加成功');
            });
          } else {
            var id;
            copyObj(_this3.active.id).then(function (res) {
              id = res.result;
              return updateObj({
                id: id,
                category: form.category,
                password: form.password,
                status: form.status,
                title: form.title
              });
            }).then(function () {
              _this3.handleEdit({
                id: id
              });

              _this3.$message.success('添加成功');
            });
          }
        }
      });
    },
    handleEdit: function handleEdit(item) {
      var routeUrl = this.$router.push({
        path: '/visual/build/' + item.id
      }); // window.location.replace(routeUrl.href);
    }
  }
};